"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const single_attack_1 = tslib_1.__importDefault(require("./single-attack"));
class NormalAttack extends single_attack_1.default {
    constructor(name = 'normal attack', rate = 1.25, FR = 0.01) {
        super(1, name, rate, 0, 1, true, FR);
    }
}
exports.default = NormalAttack;
